
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.678 7.322C37.956 2.6 31.678 0 25 0 18.322 0 12.044 2.6 7.322 7.322 2.6 12.044 0 18.322 0 25c0 6.678 2.6 12.956 7.322 17.678C12.044 47.4 18.322 50 25 50c6.678 0 12.956-2.6 17.678-7.322C47.4 37.956 50 31.678 50 25c0-6.678-2.6-12.956-7.322-17.678zM25 6.836a5.377 5.377 0 015.371 5.371A5.377 5.377 0 0125 17.578a5.377 5.377 0 01-5.371-5.371A5.377 5.377 0 0125 6.836zm6.836 34.18H18.164v-2.93h2.93V23.438h-2.93v-2.93h10.742v17.578h2.93v2.93z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    